import React, {useState} from "react";
import {Button, FormControl, InputLabel} from "@material-ui/core";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import GenericDialog from "../../../../../ui/dialogs/generic-dialog/GenericDialog";
import Grid from "@material-ui/core/Grid";
import {getTotalHowManyFiltersApplied} from "../../../../../../shared/utils/utils";
import Typography from "@material-ui/core/Typography";
import DefaultSelect from "../../../../../ui/inputs/selects/default-select/DefaultSelect";
import {updateObject} from "../../../../../../shared/utils/updateObject";
import {useSelector} from "react-redux";
import Input from "@material-ui/core/Input/Input";

const ParametriESimFilterDialog = (props) => {
    const [currentFilters, setCurrentFilters] = useState(props.filter)
    const filterOptions = useSelector(state => state.eSimReducer.parametriESimFilterOptions.data);

    const handleApplyFilters = () => {
        props.handleFilterSearch(currentFilters)
        props.handleDialogClose()
    }

    const handleSelectChange = (e) => {
        setCurrentFilters(prevCurrentFilter => updateObject(prevCurrentFilter, {
            [e.target.name]: updateObject(prevCurrentFilter[e.target.name],
                {value: e.target.value, text: e.currentTarget.innerText})
        }))
    }

    const handleInputChange = (e) => {
        setCurrentFilters(prevCurrentFilter => updateObject(prevCurrentFilter, {
            [e.target.name]: updateObject(prevCurrentFilter[e.target.name],
                {value: e.target.value})
        }))
    }

    const dialogContent = (
        <>
            <Typography variant="h5">
                Filtri
            </Typography>

            <Grid container item
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}>
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle1">
                        Numero di Telefono
                    </Typography>
                </Grid>
                <Grid item
                      xs={12} sm={7} md={8}>
                    <FormControl fullWidth>
                        <InputLabel>Seleziona numero</InputLabel>
                        <Input
                            labelid="filterSearchLabel"
                            type="search"
                            autoComplete="off"
                            name="numeroDiTelefono"
                            onChange={handleInputChange}
                            value={currentFilters.numeroDiTelefono.value}
                            fullWidth
                        />
                    </FormControl>
                </Grid>
            </Grid>

            <Grid container item
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}>
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle1">
                        Numero Seriale
                    </Typography>
                </Grid>
                <Grid item
                      xs={12} sm={7} md={8}>
                    <FormControl fullWidth>
                        <InputLabel>Seleziona numero seriale</InputLabel>
                        <Input
                            labelid="filterSearchLabel"
                            type="search"
                            autoComplete="off"
                            name="numeroSeriale"
                            onChange={handleInputChange}
                            value={currentFilters.numeroSeriale.value}
                            fullWidth
                        />
                    </FormControl>
                </Grid>
            </Grid>

            <Grid container item
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}>
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle1">
                        Stato SIM
                    </Typography>
                </Grid>
                <Grid item
                      xs={12} sm={7} md={8}>
                    <DefaultSelect menuItems={filterOptions.statoSimList}
                                   value={currentFilters.statoSim.value}
                                   handleOnChange={handleSelectChange}
                                   label="Seleziona "
                                   name="statoSim"
                                   fullWidth
                                   hasEmptyItem/>
                </Grid>
            </Grid>

            <Grid container item
                  justifyContent="center"
                  alignItems="center"
                  spacing={2}>
                <Grid item
                      xs={12} sm={5} md={4}>
                    <Typography variant="subtitle1">
                        Esito invio
                    </Typography>
                </Grid>
                <Grid item
                      xs={12} sm={7} md={8}>
                    <DefaultSelect menuItems={filterOptions.emailInviataList}
                                   value={currentFilters.esitoInvio.value}
                                   handleOnChange={handleSelectChange}
                                   label="Seleziona"
                                   name="esitoInvio"
                                   fullWidth
                                   hasEmptyItem/>
                </Grid>
            </Grid>
        </>
    )

    const dialogActions = (
        <>
            <Grid container
                  justifyContent="space-between">
                <Button variant="outlined"
                        color="primary"
                        onClick={props.handleDialogClose}>
                    Annulla
                </Button>

                <Button variant="contained"
                        disabled={!getTotalHowManyFiltersApplied(currentFilters)}
                        onClick={handleApplyFilters}
                        color="primary">
                    Applica {getTotalHowManyFiltersApplied(currentFilters) !== 0 ?
                    ` (${getTotalHowManyFiltersApplied(currentFilters)})` : ""}
                </Button>
            </Grid>
        </>
    )
    return (
        <GenericDialog
            dialogWidth="md"
            open={props.open}
            handleDialogClose={props.handleDialogClose}
            handleDialogCloseButton={props.handleDialogClose}
            dialogContent={dialogContent}
            dialogActions={dialogActions}
            loading={false}>

            <Button variant="text"
                    color="primary"
                    onClick={props.handleDialogClose}
                    startIcon={<ArrowBackIosIcon fontSize="small"/>}>
                Indietro
            </Button>

        </GenericDialog>
    )
};

export default ParametriESimFilterDialog;
